/* ==========================================================================
   assets/door-body.js: the doors, Shop all and Master Blend door (D-077,
   wi-2026-0934). Three jobs, all document-level and idempotent (a theme-editor
   re-render re-runs init() on the new cards; the listeners are bound once):

   1. FILTERS (L239). Ported from the lego generator's JS (creative/web-legos/
      tools/doors_body.mjs `JS`). Chips narrow the L237 cards on data-format /
      data-mushrooms / data-bundle; a group or door with no visible card hides.
      One change from the lego script, needed because the live page carries the
      bundle cards in the DOM (the lego printed them only in the Bundles-on
      state): Bundles OFF hides bundle cards, Bundles ON shows ONLY bundle cards
      (L244 v2 vs v5). Plus the picked chips under the phone Filters button
      (L239 CONTRACT), which the lego drew statically.

      OPT-IN data-df-bundles="all" (search, Nate 2026-09-30): put it on the
      <ul class="sc-grid"> or ANY ancestor (e.g. the search section wrapper).
      Cards inside it show bundles by default: Bundles OFF shows EVERY card,
      Bundles ON shows only bundle cards, and a group still hides when it has
      no visible card. Scoped per card (closest()), so a door or Shop all
      without the attribute behaves exactly as before. The only other bundle
      hiding the doors do is door-body.liquid's server `hidden` on the
      bundles group, which this script's init recomputes from the cards; the
      CSS only honours [hidden], it never hides a bundle by itself.

   2. SUBSCRIBE PRICE (D-053, D-054). The server never renders a subscribe
      price. When a card nears the viewport this fetches /products/<handle>.js
      once per product, takes the cheapest selling_plan_allocation per variant
      (the family PDP buy box's rule, sections/pdp-buy-box.liquid), and writes it
      into the card; Subscribe is preselected, so the subscribe price shows as
      soon as it arrives. The toggle swap is the lego's.

   3. ADD TO CART (O3 D5). Same add path as the PDP buy box: read the cart's
      igTestGroups, POST /cart/add.js with selling_plan when Subscribe is picked,
      then ask the cart drawer (Elevar emits dl_add_to_cart itself) to refresh and open through
      the theme's cart-update pub/sub (assets/cart-drawer.js listens for it).
      A BUNDLE card add then writes cart attributes bundle_id (product metafield
      custom.bundle_id, as the PDP) + bundle_src=shop_sku_card (enumerated in
      ops/lp_measurement/config.yml); a single-SKU add writes neither.
   ========================================================================== */
(function () {
  if (window.__omDoorBody) { window.__omDoorBody.init(document); return; }

  // ---------------------------------------------------------------- filters
  var state = { format: new Set(), mushroom: new Set(), bundle: false };
  var cards = function () { return Array.prototype.slice.call(document.querySelectorAll('.sc')); };

  function mirrorPicked() {
    // the phone: the picked chips sit under the Filters button, and the button counts them
    var picked = Array.prototype.slice.call(document.querySelectorAll('.df-bar [data-facet][aria-pressed="true"]'));
    document.querySelectorAll('.df-phone').forEach(function (ph) {
      var btn = ph.querySelector('[data-df-open]');
      if (btn) btn.textContent = picked.length ? 'Filters (' + picked.length + ')' : 'Filters';
      var box = ph.querySelector('.df-picked');
      if (!box) { box = document.createElement('span'); box.className = 'df-picked'; ph.appendChild(box); }
      box.textContent = '';
      picked.forEach(function (c) { box.appendChild(c.cloneNode(true)); });
    });
  }

  function apply() {
    cards().forEach(function (c) {
      var f = !state.format.size || state.format.has(c.dataset.format);
      var m = !state.mushroom.size || (c.dataset.mushrooms || '').split(' ').some(function (x) { return state.mushroom.has(x); });
      var isB = c.dataset.bundle === '1';
      // Bundles OFF: doors hide bundle cards (locked L244); an opted-in container (data-df-bundles="all") shows them
      var b = state.bundle ? isB : (c.closest('[data-df-bundles="all"]') ? true : !isB);
      c.hidden = !(f && m && b);
    });
    document.querySelectorAll('.db-group').forEach(function (g) { g.hidden = !g.querySelector('.sc:not([hidden])'); });
    document.querySelectorAll('.db').forEach(function (d) { d.hidden = !d.querySelector('.sc:not([hidden])'); });
    var any = state.format.size || state.mushroom.size || state.bundle;
    document.querySelectorAll('[data-df-clear]').forEach(function (x) { x.hidden = !any; });
    mirrorPicked();
  }

  // ------------------------------------------------------- subscribe prices
  var PLANS = {};        // variant id -> { id: selling plan id, price: cents }
  var loads = {};        // product handle -> Promise
  var money = function (cents) { return (cents / 100).toFixed(2); };

  function showPrice(buy) {
    var p = buy.querySelector('[data-price]'), p2 = buy.querySelector('[data-price2]');
    if (!p || !p2 || !buy.dataset.otp) return;
    var r = buy.querySelector('.sc-seg-input:checked');
    var sub = !!(r && r.value === 'subscribe') && !!buy.dataset.sub;
    p.textContent = '$' + (sub ? buy.dataset.sub : buy.dataset.otp);
    p2.textContent = buy.dataset.sub ? (sub ? 'one-time $' + buy.dataset.otp : 'subscribe $' + buy.dataset.sub) : 'one-time';
  }

  function fill(handle) {
    document.querySelectorAll('.sc[data-handle="' + handle + '"]').forEach(function (c) {
      var buy = c.querySelector('.sc-buy[data-otp]'), plan = PLANS[c.dataset.variantId];
      if (!buy) return;
      if (plan) buy.dataset.sub = money(plan.price);
      showPrice(buy);
    });
  }

  function ensurePlans(handle) {
    if (!handle) return Promise.resolve();
    if (loads[handle]) return loads[handle];
    loads[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        data.variants.forEach(function (dv) {
          var allocs = dv.selling_plan_allocations || [];
          if (!allocs.length) return;
          var best = allocs[0];
          allocs.forEach(function (a) { if (a.price < best.price) best = a; });
          PLANS[String(dv.id)] = { id: best.selling_plan_id, price: best.price };
        });
        fill(handle);
      })
      .catch(function () { /* no subscription figure is the honest fallback: one-time stays shown */ });
    return loads[handle];
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      ensurePlans(e.target.dataset.handle);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function init(scope) {
    (scope || document).querySelectorAll('.sc .sc-buy[data-otp]').forEach(function (buy) {
      var c = buy.closest('.sc');
      if (io) io.observe(c); else ensurePlans(c.dataset.handle);
    });
    apply();
  }

  // ------------------------------------------------------------ add to cart
  function openDrawer() {
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'door-body' });
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === 'function') drawer.reload().then(function () { drawer.open(); });
  }

  function add(btn) {
    var c = btn.closest('.sc');
    if (!c || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var vid = btn.dataset.variantId;
    var r = c.querySelector('.sc-seg-input:checked');
    var wantSub = !!(r && r.value === 'subscribe');
    var item = { id: Number(vid), quantity: 1 };
    btn.setAttribute('aria-disabled', 'true');
    (wantSub ? ensurePlans(c.dataset.handle) : Promise.resolve())
      .then(function () {
        if (wantSub && PLANS[vid]) item.selling_plan = PLANS[vid].id;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var ig = cart && cart.attributes && cart.attributes.igTestGroups;
        if (ig) item.properties = { _igTestGroups: ig };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () {
        // bundle attribution (bundle-system D5): a BUNDLE card writes bundle_id + bundle_src together,
        // from the same source the family PDP reads (product metafield custom.bundle_id, carried on the
        // card as data-bundle-id). A single-SKU card writes NEITHER: they are order-level attributes and
        // writing one would overwrite a bundle already in the cart.
        if (c.dataset.bundle !== '1') return;
        var bundleId = c.dataset.bundleId || '';
        if (!bundleId) { console.warn('door-body: bundle card has no custom.bundle_id; bundle attributes not written', c.dataset.handle); return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { bundle_id: bundleId, bundle_src: 'shop_sku_card' } })
        });
      })
      .then(function () {
        // No manual dl_add_to_cart: Elevar's cart listener already emits one per
        // /cart/add.js (a manual push double-counted add_to_cart in GA4; O9 QA E5/E6a).
        openDrawer();
        btn.removeAttribute('aria-disabled');
      })
      .catch(function () { btn.removeAttribute('aria-disabled'); });
  }

  // --------------------------------------------------------------- listeners
  document.addEventListener('change', function (e) {
    var r = e.target.closest && e.target.closest('.sc-seg-input'); if (!r) return;
    showPrice(r.closest('.sc-buy'));
  });
  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-atc="shop_sku_card"]');
    if (atc) { add(atc); return; }
    var chip = e.target.closest('[data-facet]');
    if (chip) {
      var on = chip.getAttribute('aria-pressed') !== 'true', k = chip.dataset.facet, v = chip.dataset.value;
      if (k === 'bundle') state.bundle = on; else (on ? state[k].add(v) : state[k].delete(v));
      document.querySelectorAll('[data-facet="' + k + '"][data-value="' + v + '"]').forEach(function (x) { x.setAttribute('aria-pressed', on); x.classList.toggle('is-selected', on); });
      apply();
    }
    if (e.target.closest('[data-df-clear]')) {
      state.format.clear(); state.mushroom.clear(); state.bundle = false;
      document.querySelectorAll('[data-facet]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); x.classList.remove('is-selected'); });
      apply();
    }
    var s = document.querySelector('[data-df-scrim]');
    if (!s) return;
    if (e.target.closest('[data-df-open]')) s.hidden = false;
    if (e.target.closest('[data-df-close]') || e.target === s) s.hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var s = document.querySelector('[data-df-scrim]'); if (s) s.hidden = true; }
  });
  document.addEventListener('shopify:section:load', function (e) {
    state.format.clear(); state.mushroom.clear(); state.bundle = false;
    init(e.target);
  });

  window.__omDoorBody = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
})();
